// extracted by mini-css-extract-plugin
export default {"thirdPage":"ThirdPage_thirdPage__1YV+K"};